module.exports = __webpack_public_path__ + "img/runelocus.07ecacd9.png";